@if (errorCode) {
    <h2 i18n class="title-vertical-center title-white title-large">Error: {{ errorCode | errorCode }}</h2>
} @else {
    <h2 i18n class="title-vertical-center title-white title-large">Unknown error</h2>
}
